/* LUGAZI entrance: tap anywhere (or the cat) and you go IN through the icon - it grows towards you and the start page
   fades up inside it. If nobody taps for a while, the cat walks up to the icon and paws at it, then comes back. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var body = document.body;
  function view() { return body.getAttribute('data-lugazi-view') || (new URLSearchParams(location.search).get('lugazi')) || 'home'; }
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ent = document.querySelector('.lw-entrance'), img = ent && ent.querySelector('img');
  if (!ent) return;
  var entering = false, passing = false, nudgeAnims = [];

  /* 1. in through the icon */
  function enter() {
    if (entering) return; entering = true;
    nudgeAnims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); nudgeAnims = [];
    var done = function () {
      passing = true; try { ent.click(); } finally { passing = false; }
      var w = document.querySelector('.lw-world');
      if (w && !reduced) w.animate([{ scale: '.94', opacity: 0 }, { scale: '1', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.7,.2,1)' });
    };
    if (reduced || !img) { done(); return; }
    img.style.animation = 'none';
    img.animate([{ scale: '1', opacity: 1 }, { scale: '2.7', opacity: 0 }], { duration: 480, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' });
    var fade = ent.animate([{ opacity: 1 }, { opacity: 1, offset: .65 }, { opacity: 0 }], { duration: 480, fill: 'forwards' });
    fade.finished.then(done, done);
  }
  document.addEventListener('click', function (e) {
    if (passing || view() !== 'entrance') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
    if (!e.target.closest('.lw-entrance') && !e.target.closest('.lc-cat')) return;
    e.preventDefault(); e.stopImmediatePropagation(); enter();
  }, true);

  /* 3. the cat shows the way */
  var cat = document.querySelector('.lc-cat'), lastAct = Date.now(), busy = false, nextAt = Date.now() + 3200;
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (t) { addEventListener(t, function () { lastAct = Date.now(); }, { passive: true }); });
  function nudge() {
    if (busy || entering || reduced || view() !== 'entrance' || !cat || !img) return;
    var cr = cat.getBoundingClientRect(), ir = img.getBoundingClientRect();
    if (!cr.width || !ir.width) return;
    busy = true;
    var tx = (ir.left + ir.width * .5) - (cr.left + cr.width * .5);
    var ty = (ir.bottom - ir.height * .06) - cr.top;          /* the cat's head reaches the icon's lower tip */
    var faceRight = tx > 0, had = cat.classList.contains('is-right');
    var at = tx.toFixed(1) + 'px ' + ty.toFixed(1) + 'px', up = tx.toFixed(1) + 'px ' + (ty - 10).toFixed(1) + 'px', tilt = (faceRight ? -9 : 9) + 'deg';
    cat.classList.toggle('is-right', faceRight);
    var go = cat.animate([{ translate: '0 0' }, { translate: at }], { duration: 950, easing: 'cubic-bezier(.4,0,.3,1)', fill: 'forwards' });
    nudgeAnims.push(go);
    go.finished.then(function () {
      var poke = cat.animate([
        { translate: at, rotate: '0deg' }, { translate: up, rotate: tilt, offset: .25 }, { translate: at, rotate: '0deg', offset: .5 },
        { translate: up, rotate: tilt, offset: .75 }, { translate: at, rotate: '0deg' }], { duration: 640, fill: 'forwards' });
      nudgeAnims.push(poke);
      nudgeAnims.push(img.animate([{ scale: 1 }, { scale: 1.04, offset: .3 }, { scale: 1 }], { duration: 520, delay: 140 }));
      return poke.finished;
    }).then(function () {
      cat.classList.toggle('is-right', !faceRight);
      var back = cat.animate([{ translate: at }, { translate: '0 0' }], { duration: 900, easing: 'cubic-bezier(.4,0,.3,1)', fill: 'forwards' });
      nudgeAnims.push(back);
      return back.finished;
    }).then(function () {
      cat.classList.toggle('is-right', had);
      nudgeAnims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); nudgeAnims = [];
      busy = false; nextAt = Date.now() + 5500;
    }, function () { busy = false; nextAt = Date.now() + 5500; });
  }
  setInterval(function () { if (view() === 'entrance' && Date.now() > nextAt && Date.now() - lastAct > 2800) nudge(); }, 300);
})();
